var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 162,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 45h22v22H34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alert-fill",
    fill: "#2E3134",
    fillOpacity: 0.8,
    d: "M51.417 50.867l-1.284-1.284L45 54.717l-5.133-5.134-1.284 1.284L43.717 56l-5.134 5.133 1.284 1.284L45 57.283l5.133 5.134 1.284-1.284L46.283 56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 133h28v28H33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alert-fill",
    fill: "#2E3134",
    fillOpacity: 0.8,
    d: "M55.167 140.467l-1.634-1.634L47 145.367l-6.533-6.534-1.634 1.634L45.367 147l-6.534 6.533 1.634 1.634L47 148.633l6.533 6.534 1.634-1.634L48.633 147z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 41h28v28h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alert-fill",
    fill: "#2E3134",
    fillOpacity: 0.8,
    d: "M254.167 48.467l-1.634-1.634L246 53.367l-6.533-6.534-1.634 1.634L244.367 55l-6.534 6.533 1.634 1.634L246 56.633l6.533 6.534 1.634-1.634L247.633 55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 119h28v28h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "alert-fill",
    fill: "#2E3134",
    fillOpacity: 0.8,
    d: "M239.167 126.467l-1.634-1.634-6.533 6.534-6.533-6.534-1.634 1.634 6.534 6.533-6.534 6.533 1.634 1.634 6.533-6.534 6.533 6.534 1.634-1.634-6.534-6.533z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 4.5,
    r: 3.5,
    className: "alert-stroke",
    stroke: "#2E3134",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 112.5,
    r: 3.5,
    className: "alert-stroke",
    stroke: "#2E3134",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.5,
    cy: 86.5,
    r: 3.5,
    className: "alert-stroke",
    stroke: "#2E3134",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.5,
    cy: 102.5,
    r: 3.5,
    className: "alert-stroke",
    stroke: "#2E3134",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223,
    cy: 17,
    r: 7,
    className: "alert-stroke",
    stroke: "#2E3134",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 99,
    r: 7,
    className: "alert-stroke",
    stroke: "#2E3134",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "alert-fill",
    fill: "#2E3134",
    fillOpacity: 0.8,
    fillRule: "nonzero",
    d: "M215 86c0-41.974-34.026-76-76-76S63 44.026 63 86s34.026 76 76 76 76-34.026 76-76zM67 86c0-39.765 32.235-72 72-72s72 32.235 72 72-32.235 72-72 72-72-32.235-72-72z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "alert-fill",
    fill: "#56585B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136 109h6v15h-6zM136 48h6v46h-6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1aeccba1.svg";
export { ForwardRef as ReactComponent };